"use client";

import {
  createContext,
  useContext,
  useState,
  Dispatch,
  SetStateAction,
} from "react";

type NavigationMenuContextValue = {
  megamenu: number;
  setMegamenu: Dispatch<SetStateAction<number>>;
  activeColumn: number | null;
  setActiveColumn: Dispatch<SetStateAction<number | null>>;
};

const NavigationMenuContext = createContext<
  NavigationMenuContextValue | undefined
>(undefined);

export function NavigationMenuProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [megamenu, setMegamenu] = useState(0);
  const [activeColumn, setActiveColumn] = useState<number | null>(null);

  return (
    <NavigationMenuContext.Provider
      value={{ megamenu, setMegamenu, activeColumn, setActiveColumn }}
    >
      {children}
    </NavigationMenuContext.Provider>
  );
}

export function useNavigationMenu(): NavigationMenuContextValue {
  const context = useContext(NavigationMenuContext);
  if (!context) {
    throw new Error(
      "useNavigationMenu must be used within NavigationMenuProvider",
    );
  }
  return context;
}
